export const LOGIN = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  UPDATE_SELECTED_COMPANY: "UPDATE_SELECTED_COMPANY",
  CLEAN_ERROR: "CLEAN_ERROR",
};

export const USER = {
  SET_USER: "SET_USER",
  CLEAN_USER: "CLEAN_USER",
  GET_USERS: "GET_USERS",
  GET_USERS_FAILURE: "GET_USERS_FAILURE",
  GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
  GET_ALL_USERS: "GET_ALL_USERS",
  GET_ALL_USERS_FAILURE: "GET_ALL_USERS_FAILURE",
  GET_ALL_USERS_SUCCESS: "GET_ALL_USERS_SUCCESS",
  CREATE_USER: "CREATE_USER",
  CREATE_USER_FAILURE: "CREATE_USER_FAILURE",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  DELETE_USER: "DELETE_USER",
  DELETE_USER_FAILURE: "DELETE_USER_FAILURE",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_USER_FAILURE: "UPDATE_USER_FAILURE",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  DEFINE_PASSWORD: "DEFINE_PASSWORD",
  DEFINE_PASSWORD_FAILURE: "DEFINE_PASSWORD_FAILURE",
  DEFINE_PASSWORD_SUCCESS: "DEFINE_PASSWORD_SUCCESS",
  CLEAN_ERROR: "CLEAN_ERROR",
  RESET: "RESET",
};

export const PATIENT = {
  CLEAN_PATIENT: "CLEAN_PATIENT",
  GET_PATIENTS: "GET_PATIENTS",
  GET_PATIENTS_FAILURE: "GET_PATIENTS_FAILURE",
  GET_PATIENTS_SUCCESS: "GET_PATIENTS_SUCCESS",
  CREATE_PATIENT: "CREATE_PATIENT",
  CREATE_PATIENT_FAILURE: "CREATE_PATIENT_FAILURE",
  CREATE_PATIENT_SUCCESS: "CREATE_PATIENT_SUCCESS",
  GET_PATIENT: "GET_PATIENT",
  GET_PATIENT_FAILURE: "GET_PATIENT_FAILURE",
  GET_PATIENT_SUCCESS: "GET_PATIENT_SUCCESS",
  UPDATE_PATIENT: "UPDATE_PATIENT",
  UPDATE_PATIENT_FAILURE: "UPDATE_PATIENT_FAILURE",
  UPDATE_PATIENT_SUCCESS: "UPDATE_PATIENT_SUCCESS",
  DELETE_PATIENT: "DELETE_PATIENT",
  DELETE_PATIENT_FAILURE: "DELETE_PATIENT_FAILURE",
  DELETE_PATIENT_SUCCESS: "DELETE_PATIENT_SUCCESS",
  SET_OFFSET: "SET_OFFSET",
  SET_QUERY: "SET_QUERY",
  SET_NO_SUBSCRIPTION: "SET_NO_SUBSCRIPTION",
  SET_MODULE_FILTER: "SET_MODULE_FILTER",
  CLEAN_ERROR: "CLEAN_ERROR",
};

export const COMPANY = {
  CLEAN_COMPANY: "CLEAN_COMPANY",
  GET_COMPANIES: "GET_COMPANIES",
  GET_COMPANIES_FAILURE: "GET_COMPANIES_FAILURE",
  GET_COMPANIES_SUCCESS: "GET_COMPANIES_SUCCESS",
  GET_COMPANY: "GET_COMPANY",
  GET_COMPANY_FAILURE: "GET_COMPANY_FAILURE",
  GET_COMPANY_SUCCESS: "GET_COMPANY_SUCCESS",
  CREATE_COMPANY: "CREATE_COMPANY",
  CREATE_COMPANY_FAILURE: "CREATE_COMPANY_FAILURE",
  CREATE_COMPANY_SUCCESS: "CREATE_COMPANY_SUCCESS",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  UPDATE_COMPANY_FAILURE: "UPDATE_COMPANY_FAILURE",
  UPDATE_COMPANY_SUCCESS: "UPDATE_COMPANY_SUCCESS",
  DELETE_COMPANY: "DELETE_COMPANY",
  DELETE_COMPANY_FAILURE: "DELETE_COMPANY_FAILURE",
  DELETE_COMPANY_SUCCESS: "DELETE_COMPANY_SUCCESS",
  SET_OFFSET: "SET_OFFSET",
  SET_QUERY: "SET_QUERY",
  CLEAN_ERROR: "CLEAN_ERROR",
};

export const SUBSCRIPTION = {
  ADD_PATIENT_SUBSCRIPTION: "ADD_PATIENT_SUBSCRIPTION",
  ADD_PATIENT_SUBSCRIPTION_FAILURE: "ADD_PATIENT_SUBSCRIPTION_FAILURE",
  ADD_PATIENT_SUBSCRIPTION_SUCCESS: "ADD_PATIENT_SUBSCRIPTION_SUCCESS",
  REMOVE_PATIENT_SUBSCRIPTION: "REMOVE_PATIENT_SUBSCRIPTION",
  REMOVE_PATIENT_SUBSCRIPTION_FAILURE: "REMOVE_PATIENT_SUBSCRIPTION_FAILURE",
  REMOVE_PATIENT_SUBSCRIPTION_SUCCESS: "REMOVE_PATIENT_SUBSCRIPTION_SUCCESS",
  GET_SUBSCRIPTIONS: "GET_SUBSCRIPTIONS",
  GET_SUBSCRIPTIONS_FAILURE: "GET_SUBSCRIPTIONS_FAILURE",
  GET_SUBSCRIPTIONS_SUCCESS: "GET_SUBSCRIPTIONS_SUCCESS",
  GET_SUBSCRIPTION: "GET_SUBSCRIPTION",
  GET_SUBSCRIPTION_FAILURE: "GET_SUBSCRIPTION_FAILURE",
  GET_SUBSCRIPTION_SUCCESS: "GET_SUBSCRIPTION_SUCCESS",
  SET_OFFSET: "SET_OFFSET",
  SET_QUERY: "SET_QUERY",
  SET_TYPE_FILTER: "SUBSCRIPTION_SET_TYPE_FILTER",
  CLEAN_ERROR: "CLEAN_ERROR",
  CLEAN_SUBSCRIPTION: "CLEAN_SUBSCRIPTION",
  CREATE_SUBSCRIPTION: "CREATE_SUBSCRIPTION",
  CREATE_SUBSCRIPTION_FAILURE: "CREATE_SUBSCRIPTION_FAILURE",
  CREATE_SUBSCRIPTION_SUCCESS: "CREATE_SUBSCRIPTION_SUCCESS",
  UPDATE_SUBSCRIPTION: "UPDATE_SUBSCRIPTION",
  UPDATE_SUBSCRIPTION_FAILURE: "UPDATE_SUBSCRIPTION_FAILURE",
  UPDATE_SUBSCRIPTION_SUCCESS: "UPDATE_SUBSCRIPTION_SUCCESS",
  DELETE_SUBSCRIPTION: "DELETE_SUBSCRIPTION",
  DELETE_SUBSCRIPTION_FAILURE: "DELETE_SUBSCRIPTION_FAILURE",
  DELETE_SUBSCRIPTION_SUCCESS: "DELETE_SUBSCRIPTION_SUCCESS",
};

export const PAYMENT = {
  GET_PAYMENTS: "GET_PAYMENTS",
  GET_PAYMENTS_FAILURE: "GET_PAYMENTS_FAILURE",
  GET_PAYMENTS_SUCCESS: "GET_PAYMENTS_SUCCESS",
  CREATE_PAYMENT: "CREATE_PAYMENT",
  CREATE_PAYMENT_FAILURE: "CREATE_PAYMENT_FAILURE",
  CREATE_PAYMENT_SUCCESS: "CREATE_PAYMENT_SUCCESS",
  DELETE_PAYMENT: "DELETE_PAYMENT",
  DELETE_PAYMENT_FAILURE: "DELETE_PAYMENT_FAILURE",
  DELETE_PAYMENT_SUCCESS: "DELETE_PAYMENT_SUCCESS",
  SET_OFFSET: "PAYMENT_SET_OFFSET",
  SET_MONTH_YEAR: "PAYMENT_SET_MONTH_YEAR",
  SET_MODULE_FILTER: "PAYMENT_SET_MODULE_FILTER",
};

export const STATS = {
  GET_STATS_DASHBOARD: "GET_STATS_DASHBOARD",
  GET_STATS_DASHBOARD_FAILURE: "GET_STATS_DASHBOARD_FAILURE",
  GET_STATS_DASHBOARD_SUCCESS: "GET_STATS_DASHBOARD_SUCCESS",
  CLEAN_STATS: "CLEAN_STATS",
};

export const SETTINGS = {
  GET_SETTINGS_SUCCESS: "SETTINGS_GET_SETTINGS_SUCCESS",
  UPDATE_CONTACTO: "SETTINGS_UPDATE_CONTACTO",
  UPDATE_ECOGRAFIAS: "SETTINGS_UPDATE_ECOGRAFIAS",
  UPDATE_ESTUDIOS: "SETTINGS_UPDATE_ESTUDIOS",
  UPDATE_CONSULTAS: "SETTINGS_UPDATE_CONSULTAS",
  UPDATE_MODELO_ECO: "SETTINGS_UPDATE_MODELO_ECO",
  UPDATE_CONVENIOS: "SETTINGS_UPDATE_CONVENIOS",
  UPDATE_ESPECIALIDADES: "SETTINGS_UPDATE_ESPECIALIDADES",
  UPDATE_DISPLAY_TIMEZONE: "SETTINGS_UPDATE_DISPLAY_TIMEZONE",
};

export const VISIT = {
  GET_VISITS: "VISIT_GET_VISITS",
  GET_VISITS_SUCCESS: "VISIT_GET_VISITS_SUCCESS",
  GET_VISITS_FAILURE: "VISIT_GET_VISITS_FAILURE",
  CREATE_VISIT: "VISIT_CREATE_VISIT",
  CREATE_VISIT_SUCCESS: "VISIT_CREATE_VISIT_SUCCESS",
  CREATE_VISIT_FAILURE: "VISIT_CREATE_VISIT_FAILURE",
  VALIDATE_VISIT: "VISIT_VALIDATE_VISIT",
  VALIDATE_VISIT_SUCCESS: "VISIT_VALIDATE_VISIT_SUCCESS",
  VALIDATE_VISIT_FAILURE: "VISIT_VALIDATE_VISIT_FAILURE",
  DELETE_VISIT: "VISIT_DELETE_VISIT",
  DELETE_VISIT_SUCCESS: "VISIT_DELETE_VISIT_SUCCESS",
  DELETE_VISIT_FAILURE: "VISIT_DELETE_VISIT_FAILURE",
  CLEAN_VISIT: "VISIT_CLEAN_VISIT",
  SET_PATIENT_ID: "VISIT_SET_PATIENT_ID",
};

export const PATIENT_DOCUMENT = {
  GET_DOCUMENTS: "PDOC_GET_DOCUMENTS",
  GET_DOCUMENTS_SUCCESS: "PDOC_GET_DOCUMENTS_SUCCESS",
  GET_DOCUMENTS_FAILURE: "PDOC_GET_DOCUMENTS_FAILURE",
  UPLOAD_DOCUMENT: "PDOC_UPLOAD_DOCUMENT",
  UPLOAD_DOCUMENT_SUCCESS: "PDOC_UPLOAD_DOCUMENT_SUCCESS",
  UPLOAD_DOCUMENT_FAILURE: "PDOC_UPLOAD_DOCUMENT_FAILURE",
  DELETE_DOCUMENT: "PDOC_DELETE_DOCUMENT",
  DELETE_DOCUMENT_SUCCESS: "PDOC_DELETE_DOCUMENT_SUCCESS",
  DELETE_DOCUMENT_FAILURE: "PDOC_DELETE_DOCUMENT_FAILURE",
};

export const SPECIALIST = {
  CLEAN_SPECIALIST: "CLEAN_SPECIALIST",
  GET_SPECIALISTS: "GET_SPECIALISTS",
  GET_SPECIALISTS_FAILURE: "GET_SPECIALISTS_FAILURE",
  GET_SPECIALISTS_SUCCESS: "GET_SPECIALISTS_SUCCESS",
  GET_SPECIALIST: "GET_SPECIALIST",
  GET_SPECIALIST_FAILURE: "GET_SPECIALIST_FAILURE",
  GET_SPECIALIST_SUCCESS: "GET_SPECIALIST_SUCCESS",
  CREATE_SPECIALIST: "CREATE_SPECIALIST",
  CREATE_SPECIALIST_FAILURE: "CREATE_SPECIALIST_FAILURE",
  CREATE_SPECIALIST_SUCCESS: "CREATE_SPECIALIST_SUCCESS",
  UPDATE_SPECIALIST: "UPDATE_SPECIALIST",
  UPDATE_SPECIALIST_FAILURE: "UPDATE_SPECIALIST_FAILURE",
  UPDATE_SPECIALIST_SUCCESS: "UPDATE_SPECIALIST_SUCCESS",
  DELETE_SPECIALIST: "DELETE_SPECIALIST",
  DELETE_SPECIALIST_FAILURE: "DELETE_SPECIALIST_FAILURE",
  DELETE_SPECIALIST_SUCCESS: "DELETE_SPECIALIST_SUCCESS",
  SET_OFFSET: "SPECIALIST_SET_OFFSET",
  SET_QUERY: "SPECIALIST_SET_QUERY",
  CLEAN_ERROR: "SPECIALIST_CLEAN_ERROR",
  ADD_AVAILABILITY: "SPECIALIST_ADD_AVAILABILITY",
  ADD_AVAILABILITY_FAILURE: "SPECIALIST_ADD_AVAILABILITY_FAILURE",
  ADD_AVAILABILITY_SUCCESS: "SPECIALIST_ADD_AVAILABILITY_SUCCESS",
  DELETE_AVAILABILITY: "SPECIALIST_DELETE_AVAILABILITY",
  DELETE_AVAILABILITY_FAILURE: "SPECIALIST_DELETE_AVAILABILITY_FAILURE",
  DELETE_AVAILABILITY_SUCCESS: "SPECIALIST_DELETE_AVAILABILITY_SUCCESS",
};
